import { render, staticRenderFns } from "./ConfigureShiftWorkListView.vue?vue&type=template&id=13cd84a0&scoped=true"
import script from "./ConfigureShiftWorkListView.vue?vue&type=script&lang=js"
export * from "./ConfigureShiftWorkListView.vue?vue&type=script&lang=js"
import style0 from "./ConfigureShiftWorkListView.vue?vue&type=style&index=0&id=13cd84a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cd84a0",
  null
  
)

export default component.exports